import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { Context, Transitions } from "../../types"

export const confirmFirstSavingTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({
    firstSavingConfirmModal: true
  }),
  exit: assign<Context>({
    firstSavingConfirmModal: false
  }),
  on: {
    SAVE: {
      target: "#StudyPlan.save_study_plan_transition"
    },
    CLOSE: {
      target: "idle"
    }
  }
}
